export default __webpack_public_path__ + "static/media/pharmacy.339e6ebe.png";